import styled from 'styled-components';

type TagSelectorType = {
  isLabelAboveField?: boolean;
  hasAnError?: boolean;
};

export const TagSelector = styled.div<TagSelectorType>`
  display: ${(props) => (props.isLabelAboveField ? 'block' : 'flex')};
  text-align: ${(props) => (props.isLabelAboveField ? 'left' : 'right')};
  align-items: baseline;
  position: relative;
  gap: ${(props) => (props.isLabelAboveField ? 0 : 12)}px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
    text-align: left;
  }
`;

export const SelectorLabel = styled.label<TagSelectorType>`
  text-align: ${({ isLabelAboveField = false }) => (isLabelAboveField ? 'left' : 'right')};
  font-size: 14px;
  flex: 1;
  display: block;
  line-height: 21px;
  min-height: 21px;
  color: ${(props) => props.theme.colors['neutral-80']};
`;

export const InputContainer = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

export const ContentContainer = styled.div<TagSelectorType>`
  width: ${(props) => (props.isLabelAboveField ? '100%' : '50%')};
  flex-shrink: 0;
  position: relative;
`;

export const Input = styled.input`
  border: none;
  font-size: 14px;
  line-height: 21px;
  color: ${(props) => props.theme.colors['neutral-100']};
  font-weight: 400;
  height: 100%;
  width: 100%;
  outline: none;
  background: transparent;
  padding: 0.5px 0px;

  &::placeholder {
    color: ${(props) => props.theme.colors['neutral-50']};
  }
`;

export const ContentBox = styled.div<TagSelectorType>`
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid ${(props) => (props.hasAnError ? '#fc8181' : props.theme.colors['neutral-30'])};
  padding: 6px 30px 6px 12px;
  border-radius: 6px;
  flex-wrap: wrap;
  position: relative;
  transition: all 200ms cubic-bezier(0.2, 0.8, 0.4, 1);

  &:has(${Input}:focus) {
    border-color: ${(props) => props.theme.colors['secondary-60']};
    box-shadow: 0 0 0 3px rgba(168, 191, 242, 0.25);
  }
`;

export const RemoveButton = styled.button`
  position: absolute;
  right: 13px;
  display: flex;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  background: ${(props) => props.theme.colors['neutral-40']};
  transition: all 200ms cubic-bezier(0.2, 0.8, 0.4, 1);

  &:hover {
    background: #ef5b5b;
  }
`;

export const DropDownContainer = styled.div`
  width: 100%;
  position: absolute;
  z-index: 3;
  margin-top: 3px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.07);
`;

export const OptionContainer = styled.div`
  width: 100%;
  z-index: 3;
  display: flex;
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 12px;
`;

export const DropDown = styled.div`
  border: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  background: ${(props) => props.theme.colors['neutral-0']};
  border-radius: 4px;
  padding: 6px 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  max-height: 150px;
  overflow-y: scroll;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.07);
`;

export const DropDownOption = styled.button<{ $backgroundColor?: string }>`
  padding: 3px 6px;
  border: none;
  background: ${({ $backgroundColor, theme }) => $backgroundColor || theme.colors['neutral-30']};
  cursor: pointer;
  border-radius: 4px;
`;

export const DropDownOptionLabel = styled.span``;

export const HiddenOption = styled.div`
  visibility: hidden;
  display: none;
`;

export const ErrorOption = styled.span`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 14px;
  line-height: 21px;
  text-align: left;
`;

export const Overlay = styled.div`
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: 2;
  background: transparent;
`;

export const GroupLabel = styled.span`
  display: block;
  padding: 6px 0;
  color: ${({ theme }) => theme.colors['neutral-80']};
  font-size: 9px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-transform: uppercase;
`;
